import {
    ChangeDetectionStrategy,
    Component,
    Input,
    ViewEncapsulation,
} from '@angular/core';

@Component({
    selector: 'cmps-coaching-commitment-goal-summary-row',
    template: ` <div class="cmps-coaching-commitment-goal-summary-row--metric">
            {{ metric }}
        </div>
        <div class="cmps-coaching-commitment-goal-summary-row--other">
            {{ percentRemaining }}
        </div>
        <div class="cmps-coaching-commitment-goal-summary-row--other">
            <cmps-icon
                [style.fill]="daysToAchievementColor"
                [svgIcon]="daysToAchievementIcon"
            ></cmps-icon>
            <span>{{ daysToAchievement }}</span>
        </div>`,
    host: {
        class: 'cmps-coaching-commitment-goal-summary-row',
    },
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class CmpsCommitmentGoalSummaryRowComponent {
    @Input() metric: string;
    @Input() percentRemaining: string;
    @Input() daysToAchievementIcon: string;
    @Input() daysToAchievementColor: string;
    @Input() daysToAchievement: string;
}
